module.exports = " <input type=text autocomplete=off v-model=query @keydown.prevent.up=up @keydown.prevent.down=down @keydown.prevent.enter=hit @keydown.prevent.esc=reset @blur=blur :placeholder=placeholder /> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/typeahead/Input.vue
// module id = 398
// module chunks = 0